<template>
    <modal-link
        v-c-tooltip="{
            content: tooltip,
            trigger: tooltip ? ['hover', 'focus'] : [],
        }"
        :class="[$attrs.class || 'btn btn-secondary sm-full-width relative text-nowrap', { disabled }, { 'btn-icon': icon }]"
        :disabled="loading || disabled || undefined"
        :href="href"
        :max-width="maxWidth"
        @close="$emit('close')"
        @error="handleError"
        @start="loading = true"
        @success="loading = false"
    >
        <span :style="{ visibility: loading ? 'hidden' : 'visible' }" class="flex items-center gap-1 truncate">
            <slot>
                <icon v-if="icon" :icon="icon" />
            </slot>
        </span>
        <span v-if="loading" class="absolute inset-0 flex items-center justify-center">
            <spinner />
        </span>
    </modal-link>
</template>

<script setup>
import Spinner from '@/Components/Spinner.vue';
import { ModalLink, putConfig } from '@inertiaui/modal-vue';
import { ref } from 'vue';
import Icon from '@/Components/Icon.vue';
import { eventBus, events } from '@/eventBus.js';

defineEmits(['close']);
defineProps({
    href: {
        type: String,
        required: true,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    maxWidth: {
        type: String,
        validator: (value) => ['sm', 'md', 'lg', 'xl', '2xl', '3xl', '4xl', '5xl', '6xl', '7xl'].includes(value),
    },
    icon: String,
    tooltip: String,
});

const loading = ref(false);

const handleError = (response) => {
    const error = response.response?.data?.error;
    if (!error) return;

    eventBus.$emit(events.presentFlashMessage, {
        payload: {
            message: error,
            status: 'error',
        },
    });

    loading.value = false;
};

putConfig({
    modal: {
        closeExplicitly: true,
        closeButton: false,
    },
});
</script>
